module.exports = __webpack_public_path__ + "img/card-active.ed8abc96.svg";